// WyCo Capital Landing Page Mock Data

export const siteConfig = {
  name: "WyCo Capital",
  tagline: "Backing Builders Through the Intelligence Transition.",
  subtitle: "A conviction-driven firm investing in the architects of AI and the platforms that preserve human value.",
  category: "VENTURE CAPITAL",
  email: "invest@wycocapital.ai",
  website: "WyCoCapital.ai"
};

export const thesis = [
  {
    id: "architects",
    number: "01",
    title: "The Architects",
    description: "AI is a restructuring of value. We back the deep-tech tools, agents, and infrastructure driving the efficiency revolution. We invest in the code that writes the future.",
    icon: "Cpu",
    color: "cyan"
  },
  {
    id: "human-layer",
    number: "02",
    title: "The Human Layer",
    description: "As AI automates the procedural, the premium on human connection skyrockets. We invest in platforms that elevate legacy, community, and the un-automatable human experience.",
    icon: "Heart",
    color: "orange"
  }
];

export const leadership = {
  name: "Dustin Henderson",
  title: "PhD, CPO",
  role: "FOUNDER & GENERAL PARTNER",
  image: "https://customer-assets.emergentagent.com/job_wyco-capital/artifacts/r763l754_image.png",
  bio: [
    "A builder backing builders at the intersection of AI and human connection. With deep roots in product architecture and enterprise AI, Dustin brings a rare combination: the technical fluency to evaluate the architects reshaping our world, and the conviction to partner with founders building what machines cannot replace.",
    "His PhD in Christian Leadership anchors WyCo's thesis that technology should serve human flourishing—not diminish it. This dual lens drives every investment decision: backing the infrastructure of the intelligence revolution while championing platforms that preserve legacy, community, and the irreplaceable value of human relationship."
  ],
  socialLinks: {
    linkedin: "#",
    twitter: "#"
  }
};

export const portfolioEfficiency = [
  {
    id: "truecontext",
    category: "INFRASTRUCTURE",
    name: "TrueContext.AI",
    description: "The Intelligent Backbone. Providing the structured data layer that allows enterprise AI to function with precision and recall."
  },
  {
    id: "stackranked",
    category: "HUMAN CAPITAL",
    name: "StackRanked.ai",
    description: "The first platform to bridge product vision directly to developer AI agents via MCP. Replaces static specs with active context, ensuring teams ship exactly what was designed with zero ambiguity."
  }
];

export const portfolioHuman = [
  {
    id: "memily",
    category: "LEGACY",
    name: "Memily.ai",
    description: "Preserving Generational Wisdom. A secure, AI-assisted platform for families to capture, curate, and pass down their defining stories."
  },
  {
    id: "alphacollective",
    category: "COMMUNITY",
    name: "AlphaCollective.com",
    description: "The New Social Capital. An exclusive, verified network for high-agency individuals to collaborate in a post-institutional world."
  }
];

export const socialLinks = [
  { name: "Twitter/X", url: "#", icon: "Twitter" },
  { name: "LinkedIn", url: "#", icon: "Linkedin" }
];
